<template lang="">
  <div class="flex-fill">
    <section v-if="struktur && struktur.img_cover" id="struktur" class="" style="background-image: url('static/img/default/banner-new.png'); background-size: contain; background-repeat: no-repeat; background-position: top right; ">
      <div class="container py-20">
        <span class="d-block text-white text-center mb-15 font-weight-boldest font-size-xl px-5">
          {{ struktur.name }}
          <span v-for="(d, index) in struktur.period" :key="index + '-period'">
            <span v-if="index !== 0">-</span>
            {{ d | parse('year') }}
          </span>
        </span>
        <img class="img-fluid" :src="struktur.img_cover.url" alt="" />
      </div>
      <div class="container py-20">
        <span class="d-block text-center mb-15 font-weight-boldest font-size-xl">
          Daftar Pengurus SEKAR HK Periode
          <span v-for="(d, index) in struktur.period" :key="index + '-period'">
            <span v-if="index !== 0">-</span>
            {{ d | parse('year') }}
          </span>
        </span>
        <div class="mb-15" v-for="(s, index) in struktur.structural_components" :key="index + '-structural_components'">
          <span class="d-block mb-10 text-center text-uppercase font-size-h1 font-weight-boldest mb-5">{{ s.name }}</span>
          <div class="d-flex flex-wrap justify-content-center">
            <div class="m-2 min-w-300px max-w-300px" v-for="(c, index) in s.organization_structure_details" :key="index + '-organization_structure_details'">
              <div class="card card-custom card-up card-stretch rounded-xl">
                <div class="card-body text-center d-flex flex-column justify-content-between align-items-center">
                  <img alt="Pic" v-if="c.img_cover" :src="c.img_cover.url" class="w-150px h-150px" style="border-radius:50%;object-fit:cover;" />
                  <img alt="Pic" v-else src="static/img/default/no-profile-new.png" class="w-150px h-150px" style="border-radius:50%;object-fit:cover;" />
                  <h4 class="card-title text-uppercase font-weight-bolder my-3">{{ c.name }}</h4>
                  <div class="text-dark-75 font-weight-bold">
                    <span class="d-block font-size-lg text-muted text-uppercase">{{ c.position_name || '-' }}</span>
                    <span class="d-block font-size-lg text-muted">{{ c.contact || '-' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-if="plans.length" id="visi-misi" class="">
      <div class="container py-20">
        <span class="section-title font-size-h4 mb-5">Program Kerja</span>
        <span class="d-block mb-15 font-weight-boldest font-size-xl">Program Kerja Sekar HK</span>
        <div class="row">
          <div v-for="(item, index) in plans" :key="index + '-plans'" class="col-12 col-lg-6 my-4">
            <div class="card card-custom card-stretch rounded-xl">
              <img alt="Pic" v-if="item.img_cover" :src="item.img_cover.url" class="img-fluid max-h-300px rounded-top-right-xl rounded-top-left-xl" style="object-fit:cover;" />
              <img alt="Pic" v-else src="static/img/default/no-photo.png" class="img-fluid max-h-300px rounded-top-right-xl rounded-top-left-xl" style="object-fit:cover;" />
              <div class="card-body">
                <span class="d-block text-center text-primary font-size-h2 font-weight-boldest text-uppercase mb-8">{{ item.name }}</span>
                <template v-if="item.description">
                  <span class="d-block font-size-lg font-weight-bolder text-muted text-uppercase mb-2">Deskripsi</span>
                  <p>{{ item.description }}</p>
                </template>
                <template v-if="item.work_plans.length">
                  <span class="d-block font-size-lg font-weight-bolder text-muted text-uppercase mb-3">Program Kerja</span>
                  <template v-for="(w, index) in item.work_plans">
                  <div :key="index + '-work_plans'" style="background: rgba(243, 246, 249, 1);" class="d-flex justify-content-between align-items-center rounded px-3 py-1 mb-2">
                    <div class="d-flex justify-content-between align-items-center">
                      <i class="ri-file-search-line mr-3 ri-2x text-dark"></i>
                      <span class="font-weight-bolder font-size-lg">Tahun {{ w.year }}</span>
                    </div>
                    <a v-if="w.img_attachment" :href="w.img_attachment.url" target="_blank" class="pointer d-flex justify-content-between align-items-center">
                      <i class="ri-download-2-fill mr-3 text-success ri-2x"></i>
                      <span class="font-weight-bolder font-size-lg text-success">Download</span>
                    </a>
                  </div>
                  </template>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: 'landing-landing',
  props: ['configs'],
  data () {
    return {
      isLoading: true,
      struktur: null,
      plans: []
    }
  },
  mounted () {
    this.getData()
  },
  watch: {
    '$route.query.opm': {
      immediate: true,
      deep: true,
      handler (e) {
        if (e) {
          try {
            this.$bvModal.show('modal-login')
          } catch (error) {
            console.log('err')
          }
        }
      }
    }
  },
  methods: {
    getAPI (method, api, param, obj = null) {
      return this.$_api[method](api, param)
        .then((res) => {
          return obj ? res.data[obj] || res.data : res.data
        })
        .catch((err) => {
          this.$_alert.error(err)
        })
    },
    async getData () {
      this.struktur = await this.getAPI('get', 'no-auth/organization-structure')
      this.plans = await this.getAPI('get', 'no-auth/work-plans/list')
      this.isLoading = false
    },
    getYTid (e) {
      // return 'https://youtube.com/embed/' + this.$youtube.getIdFromUrl(e.video) + '?playlist=' + this.$youtube.getIdFromUrl(e.video) + '&autoplay=1&controls=0&loop=1&mute=1'
      return 'https://youtube.com/embed/' + this.$youtube.getIdFromUrl(e.video)
    },
    redirect (e, data) {
      let target = null
      let params = {}
      switch (e) {
        case 'news':
          target = 'sekar-news'
          params = { pid: data.id, code: data.code }
          break
        case 'gallery_folders':
          target = 'sekar-gallery'
          params = { pid: data.id, code: data.code }
          break
        case 'config_votings':
          target = 'sekar-vote'
          params = { pid: data.id, code: data.code }
          break
        case 'forums':
          target = 'sekar-forum'
          params = { pid: data.id, code: data.code }
          break
        default:
          target = null
          break
      }
      if (target) {
        this.$router.push({ name: target, query: params })
      }
    }
  }
}
</script>
<style lang="">
  .section-title {
    display: block;
    position: relative;
    font-weight: 600;
    padding-left: 55px;
  }
  .section-title:before {
    content: '';
    position: absolute;
    left: 0;
    top: calc(50% - 1px);
    width: 35px;
    height: 1px;
    border-top: 4px solid var(--secondary-theme);
  }

  .hero-banner {
    min-height: 70vh;
    padding: 68px;
  }
  .hero-banner .hero-caption {
    font-size: 18px;
    font-weight: 600;
    color: var(--white);
  }
  .hero-banner .hero-cta {
    font-size: 15px;
    color: var(--white);
    text-decoration: underline;
  }
  @media only screen and (min-width: 1190px) {
    .hero-banner .hero-caption {
      font-size: 38px;
      max-width: 60%;
    }
    .hero-banner .hero-cta {
      font-size: 25px;
    }
  }

  .iframe-wrapper iframe {
    -moz-border-radius: 23px;
    border-radius: 23px;
    overflow: hidden;
  }
  .img-news-thumb {
    width: 100%;
    aspect-ratio: 1 / 1;
    border-radius: 23px;
    object-fit: cover;
  }
  .img-voting-thumb {
    width: 100%;
    aspect-ratio: 1 / 0.5;
    border-radius: 23px;
    object-fit: cover;
  }
</style>



// WEBPACK FOOTER //
// src/landing-page/organisasi.vue